import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { RiIndeterminateCircleLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import styles from './common.module.scss';

import actions from '@/actions';
import ConfirmSlider from '@/components/ui/ConfirmSlider';
import useMissionCommand from '@/hooks/command/mavlink/useMissionCommand';
import { NotifierService as notifier } from '@/libs/Notifier';
import { executeMavLinkCommand } from '@/utils/CommandUtils';

const cx = classNames.bind(styles);

const Panel = ({ data: robots }) => {
  const dispatch = useDispatch();
  const [isProcessing, setProcessing] = useState(false);
  const missionCommand = useMissionCommand();

  //#region Process Functions
  const process = async (robot) => {
    try {
      await executeMavLinkCommand(robot, missionCommand.clear(0));
      await executeMavLinkCommand(robot, missionCommand.clear(1));

      onSuccess(robot);
    } catch (error) {
      onFailure(robot);
    }
  };
  //#endregion

  //#region Result Handlers
  // 성공 시 처리
  const onSuccess = (robot) => {
    dispatch(actions.missions.unload(robot.id));

    notifier.success(`Mission cleared successfully from ${robot.name}.`);
    setProcessing(false);
  };

  // 실패 시 처리
  const onFailure = (robot) => {
    notifier.error(`Failed to clear mission from ${robot.name}.`);
    setProcessing(false);
  };
  //#endregion

  useUpdateEffect(() => {
    if (!isProcessing) {
      dispatch(actions.command.resetActivePanels());
      return;
    }

    robots.forEach((robot) => process(robot));
  }, [isProcessing]);

  const doCommand = () => {
    // 처리 중 상태로 변경
    setProcessing(true);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('desc')}>Clears all mission data from vehicle</div>
      <ConfirmSlider
        width="100%"
        height={40}
        onConfirm={doCommand}
        isProcessing={isProcessing}
        labelStyle={{ fontSize: 12 }}
      />
    </div>
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Clear';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiIndeterminateCircleLine;
Command.Panel = Panel;

export default Command;
